class Logo {
    constructor() {
        this.body = document.querySelector('body');
        this.logo = document.querySelector('.js-navbar-logo');
    }

    init() {
        if (this.logo) {
            this.calculateScrollPosition();
        }
    }

    calculateScrollPosition() {
        const rect = this.body.getBoundingClientRect();

        if (rect.top < 0) {
            this.logo.parentElement.classList.add('is-scaled')
            this.logo.classList.add('is-scaled')
        } else {
            this.logo.parentElement.classList.remove('is-scaled')
            this.logo.classList.remove('is-scaled')
        }

        requestAnimationFrame(this.calculateScrollPosition.bind(this));
    }
}

export default new Logo();
